<template>
  <div class="meal-container">
    <!-- Create Meal Form -->
    <v-container grid-list-md>
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Edit Meal</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-data-table
          v-model="foodSelected"
          :headers="foodHeaders"
          :items="foods"
          item-key="id"
          select-all
          :search="search"
        >
          <template slot="items" slot-scope="props">
            <tr :active="props.selected" @click="props.selected = !props.selected">
              <td>
                <v-checkbox
                  :input-value="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td>{{ props.item.name }}</td>
              <td class="text-xs-right">{{ props.item.calories }}</td>
              <td class="text-xs-right">{{ props.item.fat }}</td>
              <td class="text-xs-right">{{ props.item.carbohydrates }}</td>
              <td class="text-xs-right">{{ props.item.protein }}</td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
        <v-form v-model="valid" class="food-form" lazy-validation>
          <v-subheader>Meal Components</v-subheader>
          <v-layout row wrap>
            <v-flex xs6 sm6 md6>
              <v-text-field v-model="name" label="Meal Name" required></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-select v-model="type" :items="types" label="Type" required></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-for="(food, id) in foodSelected" v-bind:key="id">
            <v-flex xs1 sm1 md1>
              <v-text-field label="Servings" v-model="food.portion" solo></v-text-field>
            </v-flex>
            <v-flex xs2 sm2 md2 class="input-label">
              <!-- <div>{{ food.serving }}{{ food.unit }} <span class="theme--light v-messages">/{{ food.net }}{{ food.unit }}</span></div> -->
              <!-- <v-input :messages="[food.net+food.unit]">{{ food.serving }}{{ food.unit }}</v-input> -->
              <v-input :messages="[food.serving+food.unit + '/' + food.net+food.unit]">{{ Math.round((food.serving * food.portion)*1)/1 }}{{ food.unit }}</v-input>
            </v-flex>
            <v-flex xs5 sm5 md5 class="input-label-left">
              {{ food.name }}
            </v-flex>
            <v-flex xs1 sm1 md1>
              <!-- <div>{{ food.protein * food.portion }} g</div> -->
              <v-input :messages="['Fat']">{{ Math.round((food.fat * food.portion)*10)/10 }} g</v-input>
            </v-flex>
            <v-flex xs1 sm1 md1>
              <!-- <div>{{ food.protein * food.portion }} g</div> -->
              <v-input :messages="['Carbs']">{{ Math.round((food.carbohydrates * food.portion)*10)/10 }} g</v-input>
            </v-flex>
            <v-flex xs1 sm1 md1>
              <!-- <div>{{ food.protein * food.portion }} g</div> -->
              <v-input :messages="['Protein']">{{ Math.round((food.protein * food.portion)*10)/10 }} g</v-input>
            </v-flex>
            <v-flex xs1 sm1 md1>
              <v-btn 
                flat 
                icon color="grey"
                @click="removeComponent(id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <div class="text-xs-center">
            <v-btn
              color="blue-grey"
              class="white--text"
              @click="updateMeal()"
              :disabled="!valid"
            >
              Update Meal
              <v-icon right dark>fastfood</v-icon>
            </v-btn>
            <v-btn
              color="red"
              class="white--text"
              @click="deleteMeal()"
              :disabled="!valid"
            >
              Delete Meal
              <v-icon right dark>delete</v-icon>
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-container>
    <v-snackbar v-model="snackbar">
      Meal Updated Successfully.
    </v-snackbar>
    <v-snackbar 
        v-model="deleteSuccess"
        :color="deleteSuccessColour"
    >
      Meal Deleted Successfully.
    </v-snackbar>
  </div>
</template>

<script>
import db from '@/firebase/firestore'
export default {
  name: 'Meal',
  data() {
    return {
      search: '',
      foodHeaders: [
        { text: 'Item Name', value: 'name' },
        { text: 'Calories', value: 'calories' },
        { text: 'Fat (g)', value: 'fat' },
        { text: 'Carbs (g)', value: 'carbs' },
        { text: 'Protein (g)', value: 'protein' },
      ],
      foods: [],
      foodSelected: [],
      selected: [],
      snackbar: false,
      deleteSuccess: false,
      deleteSuccessColour: 'error',
      valid: true,
      loading: true,
      types: [
        'Dinner',
        'Lunch',
        'Breakfast',
        'Snack',
        'Stack'
      ],
      meal: null,
      name: null,
      type: null
    }
  },
  methods: {
    removeComponent(index) {
      alert(index)
      console.log(this.foodSelected)
      this.foodSelected.splice(index,1)
      console.log(this.foodSelected)
      // remove(this.foodSelected[index])
    },
    deleteMeal() {
      this.valid = false
      let mealRef = db.collection('meals').doc(this.$route.params.id).delete()
      .then( (snapshot) => {
        this.deleteSuccess = true
        this.$router.push({ name: 'Meal'})
        // console.log('snapshot delete', snapshot)
        this.valid = true
      })
    },
    updateMeal() {
      let components = []
      let totalCost = 0
      let totalProtein = 0
      let totalFat = 0
      let totalCarbohydrates = 0
      let totalCalories = 0
      this.valid = false
      this.foodSelected.forEach( food => {
        // Calculate Properties
        let cost = Math.round(((food.portion*food.serving)/food.net)*food.price*100)/100
        let protein = food.portion*food.protein
        let fat = food.portion*food.fat
        let carbohydrates = food.portion*food.carbohydrates
        let calories = food.portion*food.calories
        // 
        console.log('food id', food.id)
        if( food.id ) {
            components.push({
            id: food.id,
            portion: parseFloat(food.portion),
            cost: cost
          })
        } else {
          alert(food.name + ' has an invalid id and will be removed.')
        }
        // Calculate Sums
        totalProtein += protein
        totalFat += fat
        totalCarbohydrates += carbohydrates
        totalCost += cost
        totalCalories += calories
      });
      var updated = {
        name: this.name,
        type: this.type,
        components: components,
        totalCalories: totalCalories,
        totalCarbohydrates: Math.round(totalCarbohydrates*100)/100,
        totalCost: Math.round(totalCost*100)/100,
        totalFat: Math.round(totalFat*100)/100,
        totalProtein: Math.round(totalProtein*100)/100
      }
      console.log('set',updated)
      let mealRef = db.collection('meals').doc(this.$route.params.id).set(updated).then((result) => {
        console.log(result)
        this.snackbar = true
        this.valid = true
      })
    }
  },
  created () {
    // Load Meal
    let mealRef = db.collection('meals').doc(this.$route.params.id).get()
    .then((snapshot) => {
        if( snapshot.exists ) {
            this.meal = snapshot.data()
            //console.log('MEAL',this.meal)
            this.name = this.meal.name
            this.type = this.meal.type
            this.meal.components.forEach( (component) => {
                let foodRef = db.collection('food').doc(component.id).get()
                .then((snapshot) => {
                    // console.log('FOOD',snapshot.data())
                    let food = snapshot.data()
                    food.portion = component.portion
                    food.fat = food.fat.total
                    food.carbohydrates = food.carbohydrates.total
                    this.foodSelected.push(food)
                })
            })
        } 
    })
    // Load Foods
    let ref = db.collection('food')
    ref.get().then((snapshot) => {
      this.loading = false
      snapshot.forEach( doc => {
        let food = doc.data()
        this.foods.push({
          id: doc.id,
          name: food.name,
          calories: food.calories,
          fat: food.fat.total,
          carbohydrates: food.carbohydrates.total,
          protein: food.protein,
          serving: food.serving,
          unit: food.unit,
          net: food.net,
          price: food.price,
          // 
          portion: Math.round((food.net/food.serving)*100)/100,
          selected: false
        })
      })
    })
  }
}
</script>

<style scoped>
  .add {
    margin-top: 10px;
  }
  .food-form {
    padding: 20px;
    margin: 0 16px;
  }
  .v-subheader {
    padding: 0;
  }
  .input-label {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    font-size: 16px
  }
  .input-label-left {
    display: flex;
    align-items: center;
    justify-content: left;
    height: 48px;
    font-size: 16px
  }
</style>
